import { createGlobalStyle } from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";
import { PUBLIC_URL } from "../../../config";

export const GlobalStyled = createGlobalStyle`
    :root {
        // @deprecated
        --color-base: #131420;
        --color-base-secondary: #1B1C2D;
        --color-main: #42456C;
        --color-surface: #262840;
        --color-surface-50: #26284080;
        --color-surface-primary: #262840;
        --color-surface-highlight: #393C60;
        --color-surface-secondary: #31324E;
        --color-yellow: #FFFC57;
        --color-yellow-60: #FFFC5799;
        --color-yellow-80: #FFFC57CC;
        --color-yellow-light: #FEFA7B;
        --color-yellow-dark: #8D8C42;
        --color-white: #FFFFFF;
        --color-white-50: #FFFFFF80;
        --color-white-60: #FFFFFF99;
        --color-white-80: #FFFFFFCC;
        --color-white-95: #FFFFFFF2;
        --color-purple: #393C5D;
        --color-purple-highlight: #5F649B;
        --color-green: #54EEAB;
        --color-green-secondary: #14C679;
        --color-green-secondary-20: #14C67933;
        --color-red: #FF858B;
        --color-red-secondary: #D05257;
        --color-black: #2A2B30;
        --color-secondary: #BDC0DB;
        --color-secondary-active: #7D86B2;
        --color-secondary-highlight: #B9BFDF;
        --color-positive: #54EEAB;
        --color-negative: #FF858B;
        --color-negative-secondary: #FF646C;
        --color-negative-secondary-20: #FF646C33;
        --color-negative-lite: #FF999E;
        --color-neutral: #8192E4;
        --color-neutral-5: #8192E40D;
        --color-neutral-10: #8192E41A;
        --color-neutral-20: #8192E433;
        --color-neutral-40: #8192E466;
        --color-tertiary: #0A0A10; // instead of --color-tertiary use --color-label-primary-inverted
        --color-tertiary-30: #0A0A104D;
        --color-tertiary-50: #0A0A1080;
        --color-tertiary-70: #0A0A10B2;
        --color-neutral-secondary: #BAC0DE;

        --text-color-secondary: var(--color-label-secondary);
        --text-color-dark: #0A0A10;

        --app-bg-color: #131420;
        --app-bg-header-color: #1E1F30;
        --app-bg-modal-color: var(--color-surface);
        --app-bg-modal-header-color: var(--color-surface-secondary);
        --app-bg-modal-panel-color: var(--color-surface-secondary);
        --dx-bg-color: var(--color-surface-secondary);

        --brand-color: #FFDD3C;

        --icon-primary-color: #CAD0E7;
        --background-base: #0A0A10;
        --background-logo: #1A1B23;
        --background-positive: #14C679;
        --background-positive-20: #14C67933;
        --background-positive-10: #14C67919;

        --background-dark-quaternary: #373858;

        --gradients-yellow-pink: linear-gradient(139deg, #FFFC57 25.69%, #FFDAB9 67.96%);

        --button-primary-highlight: #FEFA7B;

        --border-radius: 16px;
    }

    :root, [data-theme='dark'] {
        --color-background-reduced: #131420;
        --color-background-primary: #1B1C2D;
        --color-background-secondary: #262840;
        --color-background-tertiary: #31324E;
        --color-background-quaternary: #373858;
        --color-background-quinary: #42456C;
        --color-background-secondary-to-primary: #262840;
        --color-background-quaternary-to-secondary: #373858;

        --color-label-primary: #FFFFFFF2;
        --color-label-secondary: #FFFFFF99;
        --color-label-tertiary: #FFFFFF4D;
        --color-label-quaternary: #FFFFFF2E;
        --color-label-primary-inverted: #000000;
        --color-label-positive: #54EEAB;
        --color-label-positive-transparent: #54EEAB99;
        --color-label-negative: #FF858B;
        --color-label-negative-transparent: #FF858B99;
        --color-label-accent: #FFFC57;
        --color-label-pink: #FF85B1;

        --color-button-primary-default: #FFFC57;
        --color-button-primary-highlight: #FEFA7B;
        --color-button-primary-inactive: #8D8C42;

        --color-button-secondary-default: #8192E41A;
        --color-button-secondary-highlight: #8192E433;
        --color-button-secondary-inactive: #8192E40D;

        --color-button-sell-default: #BAC0DE;
        --color-button-sell-highlight: #DDE2FF;
        --color-button-sell-inactive: #727687;

        --color-button-buy-default: #8192E4;
        --color-button-buy-highlight: #A8B7FF;
        --color-button-buy-inactive: #565E8A;

        --color-fill-primary: #8192E433;
        --color-fill-primary-bg-overlay: #1B1C2D80;
        --color-fill-secondary: #8192E41A;
        --color-fill-tertiary: #8192E40D;
        --color-fill-transparent-solid: #8192E41A;
        --color-fill-accent: #FFDD3C1A;
        --color-fill-positive: #14C67933;
        --color-fill-attention: #FFA8571A;
        --color-fill-negative: #FF646C33;
        --color-fill-backing: none;
        --color-fill-pink: #F6C6EC1A;

        --color-overlay-primary: #0F1214CC;
        
        --color-divider: #42456C;
        --color-divider-filled: #1B1C2D;
        --color-divider-transparent: #0A0A1180;

        --shadow-primary: none;
        --shadow-bottom-overlay: 0 0 25px rgb(0 0 0 / 25%);
        --shadow-bottom-sheet: none;

        --gradient-primary: linear-gradient(225deg, #FFDAB9 -8.1%, #FFEF7D 16.46%, #FFFC57 48.19%, #F0FC69 82.93%, #C0FCA3 106.88%);
        --gradient-green-violet: linear-gradient(139deg, #C0FCA3 13.35%, #C2C5FF 67.96%);
        --gradient-green-pink: linear-gradient(139deg, #C0FCA3 13.35%, #FFDAB9 67.96%);
        --gradient-yellow-pink: linear-gradient(139deg, #FFFC57 25.69%, #FFDAB9 67.96%);
        --gradient-pink-violet: linear-gradient(139deg, #FFDAB9 13.35%, #C2C5FF 67.96%);
        --gradient-green-yellow: linear-gradient(139deg, #C0FCA3 13.35%, #FFFC58 67.96%);
        --gradient-yellow-violet: linear-gradient(139deg, #FFFC58 13.35%, #C2C5FF 67.96%);
        --gradient-yellow-red: linear-gradient(228deg, #FF837B 39.41%, #FFFD84 113.77%);
        --gradient-flory-arena-card: radial-gradient(circle at 0% 100%, rgba(251, 247, 122, 1) 0%, rgba(251, 247, 122, 0) 65%),
        radial-gradient(circle at 50% 50%, rgba(183, 188, 212, 1) 0%, rgba(183, 188, 212, 0) 70%);

        --color-label-neutral-primary-white: #FFFFFFF2;
        --color-label-neutral-primary-black: #0A0A10;
        --color-label-neutral-secondary-white: #FFFFFF99;
        --color-label-neutral-secondary-black: #0A0A10B2;
        --color-label-neutral-tertiary-black: #0A0A104D;
        --color-label-neutral-tertiary-white: #FFFFFF4D;

        --color-background-neutral-primary-black: #1B1C2D;
        --color-background-neutral-secondary-black: #262840;
        --color-background-neutral-tertiary-black: #31324E;

        --color-background-neutral-primary-white: #F3F3F6;
        --color-background-neutral-secondary-white: #FFFFFF;
        --color-background-neutral-tertiary-white: #EDEDF1;

        --color-background-neutral-error: #492A3A;

        --bg-image-coin-stack: url('${PUBLIC_URL}/assets/portfolio/coin-stack.png');
        --bg-image-most-popular: url('${PUBLIC_URL}/assets/widgets/most-popular.png');
        --bg-image-logo-short: url('${PUBLIC_URL}/assets/logo/logo-short.svg');
    }

    [data-theme='dark'][data-platform='desktop'] {
        --color-background-primary: #1B1C2D;
        --color-background-secondary: #262840;
        --color-background-reduced: #131420;
    }

    [data-theme='light'] {
        --color-background-reduced: #F2F2F8;
        --color-background-primary: #FAFAFC;
        --color-background-secondary: #FFFFFF;
        --color-background-tertiary: #EDEDF1;
        --color-background-quaternary: #DDDDE5;
        --color-background-quinary: #A3A5B8;
        --color-background-secondary-to-primary: #FAFAFC;
        --color-background-quaternary-to-secondary: #FFFFFF;

        --color-label-primary: #292929F2;
        --color-label-secondary: #29292999;
        --color-label-tertiary: #2929294D;
        --color-label-quaternary: #2929292E;
        --color-label-primary-inverted: #FFFFFFF2;
        --color-label-positive: #34CE8B;
        --color-label-positive-transparent: #34CE8B99;
        --color-label-negative: #FD747B;
        --color-label-negative-transparent: #FD747B99;
        --color-label-accent: #F1E253;
        --color-label-pink: #ED7CA4;

        --color-button-primary-default: #F6E75D;
        --color-button-primary-highlight: #FFF27E;
        --color-button-primary-inactive: #E1D66E;

        --color-button-secondary-default: #C2C5F23B;
        --color-button-secondary-highlight: #C2C5F259;
        --color-button-secondary-inactive: #1B1C2D0D;

        --color-button-sell-default: #CAD1F4;
        --color-button-sell-highlight: #D7DEFA;
        --color-button-sell-inactive: #AAB1CF;

        --color-button-buy-default: #96A6F2;
        --color-button-buy-highlight: #B8C4FE;
        --color-button-buy-inactive: #8590C6;

        --color-fill-primary: #7C7E990D;
        --color-fill-primary-bg-overlay: #FAFAFC80;
        --color-fill-secondary: #7C7E991A;
        --color-fill-tertiary: #7C7E992B;
        --color-fill-transparent-solid: #FFFFFF;
        --color-fill-accent: #DDC23D1A;
        --color-fill-positive: #14C6791A;
        --color-fill-attention: #FFA8571A;
        --color-fill-negative: #D6555B1A;
        --color-fill-backing: #7C7E990D;
        --color-fill-pink: #EA5ACA1A;

        --color-overlay-primary: #F9F9FCCC;

        --color-divider-filled: #DDDDE7;
        --color-divider-transparent: #1B1C2D14;

        --gradient-flory-arena-card: radial-gradient(circle at 0% 100%, rgba(251, 247, 122, 1) 0%, rgba(251, 247, 122, 0) 65%),
        radial-gradient(circle at 50% 50%, rgba(183, 188, 212, 1) 0%, rgba(183, 188, 212, 0) 70%);

        --shadow-primary: 0px 2px 16px 0px rgba(20, 24, 41, 0.06);
        --shadow-bottom-overlay: 0px -6px 20px 0px rgba(27, 28, 45, 0.10);
        --shadow-bottom-sheet: 0px -10px 30px 10px rgba(27, 28, 45, 0.15);

        --bg-image-coin-stack: url('${PUBLIC_URL}/assets/portfolio/coin-stack-light.png');
        --bg-image-most-popular: url('${PUBLIC_URL}/assets/widgets/most-popular-light.png');
        --bg-image-logo-short: url('${PUBLIC_URL}/assets/logo/logo-short-light.svg');
        
        &[data-platform='desktop'] {
            --color-background-primary: #FFFFFF;
            --color-background-secondary: #FAFAFC;
            --color-background-reduced: #FAFAFC;
        }
    }

    html, body {
        height: 100%;
    }

    #root {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    body {
        font-family: "OpenSans", "NotoSans", sans-serif;
        font-size: 16px;
        font-weight: 400;

        background-color: var(--color-background-primary);
        color: var(--color-label-primary);
        margin: 0;
        padding: 0;
    }

    .app {

        @media (max-width: ${BREAKPOINTS.medium}px) {
            * {
                user-select: none;
            }

            input, textarea {
                user-select: text;
            }

            textarea {
                resize: none;
            }
        }

    }

    h1, h2, h2, h3, h4, h5, h6 {
        user-select: none;
    }

    .positive {
        color: var(--color-label-positive) !important;
    }

    .negative {
        color: var(--color-label-negative) !important;
    }


    /**
     * Typographic
     */

    h1 {
        font-size: 40px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 32px;
        }
    }

    h2 {
        font-size: 32px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.extraSmall}px) {
            font-size: 28px;
        }
    }

    h3 {
        font-size: 28px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.extraSmall}px) {
            font-size: 24px;
        }
    }

    h4 {
        font-size: 24px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.extraSmall}px) {
            font-size: 20px;
        }
    }

    h5 {
        font-size: 20px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.extraSmall}px) {
            font-size: 16px;
        }
    }

    h6 {
        font-size: 16px;
        font-weight: 600;
    }

    @media (max-width: ${BREAKPOINTS.extraExtraLarge}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.large}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        body {
            font-size: 16px;
        }
    }

    @media (max-width: ${BREAKPOINTS.extraSmall}px) {
        body {
            font-size: 14px;
        }
    }

    a[type='button'] {
        -webkit-appearance: none;
    }

    .flex-row {
        display: flex;
        flex-direction: row;

        > * {
            flex: 1 1 auto;
        }
    }

    /**
     * BOOTSTRAP    
     */

    .dropdown-menu {
        background-color: var(--color-background-secondary);
        border: none;
        box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
        border-radius: 16px;
    }

    .dropdown-divider {
        margin: 0;
        border-top: 1px solid var(--color-divider-transparent);
        opacity: 1;
    }

    .dropdown-header {
        font-size: 14px;
        font-weight: 400;
        color: var(--color-label-secondary);
        padding: 12px 16px;
    }

    .dropdown-item {
        font-size: 14px;
        font-weight: 600;
        color: var(--color-label-primary);
        padding: 12px 16px;

        &.secondary {
            color: var(--color-label-primary);

            &:hover,
            &:focus {
                color: var(--color-label-primary);
            }
        }

        &.active,
        &:active {
            color: var(--color-label-primary);
            background-color: var(--color-fill-secondary);
        }

        &:hover,
        &:focus {
            color: var(--color-label-primary);
            background-color: var(--color-background-secondary);
        }
    }

    .carousel .slide {
        text-align: unset;
    }

    .badge {
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
    }

    .bg-info {
        background-color: var(--color-background-secondary) !important;
    }

    hr {
        background-color: var(--color-neutral-20);
        opacity: 1;
    }

    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    /**
    * nested containers and border radius
    */
    .root-container {
        div,
        input,
        button,
        button.square,
        .container-item {
            border-radius: 16px;
        }
    }

    .nested-container {
        div,
        input,
        button,
        button.square,
        .container-item {
            border-radius: 12px;
        }
    }

    .sub-container {
        div,
        input,
        button,
        button.square,
        .container-item {
            border-radius: 8px;
        }
    }
`;
